// API endpoints
export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api/v1'

export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/users/login',
  REGISTER: '/users/register',
  REFRESH: '/users/refresh',
  ME: '/users/me',

  // Users
  USERS: '/users',

  // AI Agent
  AGENT_CHAT: '/agent/chat',
  AGENT_CHAT_STREAM: '/agent/chat/stream',

  // Attendance
  ATTENDANCE: '/attendance',
  ATTENDANCE_CHECK_IN: '/attendance/check-in',
  ATTENDANCE_CHECK_OUT: '/attendance/check-out',

  // Leave
  LEAVE_REQUESTS: '/leave/requests',
  LEAVE_BALANCE: '/leave/balance',

  // Performance
  PERFORMANCE: '/performance',
  PERFORMANCE_REVIEWS: '/performance/reviews',

  // Documents
  DOCUMENTS: '/documents',
  DOCUMENT_FOLDERS: '/documents/folders',

  // Employees
  EMPLOYEES: '/employees',
  LEVELS: '/levels',
  DEPARTMENTS: '/departments',
} as const

// HTTP status codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const

// Pagination defaults
export const DEFAULT_PAGE_SIZE = 20
export const DEFAULT_PAGE = 1
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100]

// App constants
export const APP_NAME = 'Enterprise Management System'
export const APP_SHORT_NAME = 'EMS'

// Local storage keys
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  THEME: 'theme',
  USER: 'user',
  SIDEBAR_COLLAPSED: 'sidebar_collapsed',
  SIDEBAR_MINI: 'sidebar_mini',
} as const

// Navigation items
export const NAV_ITEMS = [
  { title: 'AI 助手', href: '/', icon: 'MessageSquare', color: 'text-blue-500' },
  { title: '用户管理', href: '/users', icon: 'Users', color: 'text-green-500' },
  { title: '考勤管理', href: '/attendance', icon: 'Clock', color: 'text-orange-500' },
  { title: '绩效管理', href: '/performance', icon: 'Target', color: 'text-purple-500' },
  { title: '请假管理', href: '/leave', icon: 'Calendar', color: 'text-pink-500' },
  { title: '文档管理', href: '/documents', icon: 'FileText', color: 'text-cyan-500' },
] as const

// Leave types
export const LEAVE_TYPES = [
  { value: 'annual', label: '年假', color: 'bg-green-100 text-green-800' },
  { value: 'sick', label: '病假', color: 'bg-red-100 text-red-800' },
  { value: 'personal', label: '事假', color: 'bg-blue-100 text-blue-800' },
  { value: 'maternity', label: '产假', color: 'bg-pink-100 text-pink-800' },
  { value: 'paternity', label: '陪产假', color: 'bg-indigo-100 text-indigo-800' },
  { value: 'other', label: '其他', color: 'bg-gray-100 text-gray-800' },
] as const

// Attendance status
export const ATTENDANCE_STATUS = {
  normal: { label: '正常', color: 'bg-green-100 text-green-800' },
  late: { label: '迟到', color: 'bg-yellow-100 text-yellow-800' },
  early_leave: { label: '早退', color: 'bg-orange-100 text-orange-800' },
  absent: { label: '缺勤', color: 'bg-red-100 text-red-800' },
  overtime: { label: '加班', color: 'bg-purple-100 text-purple-800' },
} as const

// Request status
export const REQUEST_STATUS = {
  pending: { label: '待审批', color: 'bg-yellow-100 text-yellow-800' },
  approved: { label: '已通过', color: 'bg-green-100 text-green-800' },
  rejected: { label: '已拒绝', color: 'bg-red-100 text-red-800' },
  cancelled: { label: '已取消', color: 'bg-gray-100 text-gray-800' },
} as const

// Theme
export const THEME_MODES = ['light', 'dark', 'system'] as const
